"use client";

import React, { useState, useEffect, useRef } from "react";
import { cn } from "../../lib/utils";

export default function BannerCarousel({
  images = [],
  interval = 5000,       // tiempo entre slides (ms)
  showIndicators = true, // puntitos abajo
  className = "",        // para controlar tamaño desde el padre
}) {
  const [current, setCurrent] = useState(0);
  const timeoutRef = useRef(null);

  const advance = () => setCurrent((prev) => (prev + 1) % images.length);

  useEffect(() => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(advance, interval);
    return () => clearTimeout(timeoutRef.current);
  }, [current, interval, images.length]);

  if (!images.length) return null;

  return (
    <div className={cn("relative overflow-hidden", className)}>
      {/* Slides */}
      <div
        className="flex transition-transform duration-700 ease-in-out h-full"
        style={{ transform: `translateX(-${current * 100}%)` }}
      >
        {images.map((src, idx) => (
          <div key={idx} className="flex-shrink-0 w-full h-full">
            <img
              src={src}
              alt={`slide-${idx}`}
              className="w-full h-full object-cover"
            />
          </div>
        ))}
      </div>

      {/* Indicators */}
      {showIndicators && (
        <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
          {images.map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={cn(
                "w-3 h-3 rounded-full transition-colors",
                current === idx ? "bg-white" : "bg-white/50 hover:bg-white"
              )}
            />
          ))}
        </div>
      )}
    </div>
  );
}
